// src/data/policePositions.ts
// Values live in Firestore (gameConfig/policePositions); this module only reads them.
//
// `id` is a plain string rather than a literal union: positions are added and edited
// from the admin panel, so the set cannot be known at compile time. gameConfig.ts
// validates ids at load instead.
import { getDomain } from '../config/gameConfig';

export interface PolicePosition {
    id: string;
    name: string;
    departmentUnit?: string;
    requirements?: {
        minimumLevel?: number;
        completedCourses?: string[];
        minimumWorkedHours?: number;
        specialRequirements?: string[];
        attributes?: {
            strength?: number;
            agility?: number;
            dexterity?: number;
            intelligence?: number;
            endurance?: number;
        };
    };
}

export const getPolicePositions = (): PolicePosition[] => getDomain<PolicePosition>('policePositions');

export const getPositionById = (positionId: string): PolicePosition | undefined => {
    return getPolicePositions().find(pos => pos.id === positionId);
};

export const getPositionName = (positionId: string | null | undefined): string => {
    if (!positionId) return '—';
    const position = getPositionById(positionId);
    return position?.name || '—';
};
